export const BASE_URl = 'https://bitrix.mdrk.ru/B24/domofon'
export const PAYMENT_URL = 'https://rta-telecom.ru/merchant/tinkoff2'
